module.exports = __webpack_public_path__ + "img/pick5.ea2fa180.png";